export enum EditorToolbarEnum {
    Basic,
    Extended,
    Media
}